var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"blog-container vertical-scrolling",attrs:{"id":"blog"}},[_c('div',{staticClass:"blog-title-container"},[_c('h1',[_vm._v(_vm._s(_vm.$lang.blog.blog_title))]),_c('p',[_vm._v(_vm._s(_vm.$lang.blog.blog_desc))])]),_c('blog-feed',{attrs:{"feeds":_vm.feeds}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }